import {Timestamp} from "firebase/firestore";

import {timeSince} from "./timeUtils";

export const renderData = (value: unknown): string => {
  if (value instanceof Timestamp) {
    return timeSince(value.toDate());
  } else if (typeof value === "object" && value !== null) {
    return JSON.stringify(value);
  } else if (typeof value === "boolean") {
    return value ? "✓" : "✗";
  } else if (typeof value === "number") {
    return value.toFixed(4) + " s";
  } else {
    return String(value);
  }
};
